import { FCX } from "@datassential/platform-ui-lib";
import { IoChevronBack, IoChevronForward } from "react-icons/io5";
import './SliderNav.styles.scss';
import { useEffect } from "react";

const SliderNav: FCX<{
    onNext: () => void;
    onPrev: () => void;
    autoSlideIntervalMs?: number;
}> = ({
    onNext,
    onPrev,
    autoSlideIntervalMs = 0,
    style,
}) => {
    useEffect(() => {
        if (autoSlideIntervalMs) {
            const interval = setInterval(() => {
                onNext();
            }, autoSlideIntervalMs);

            return () => clearInterval(interval);
        }
    }, [autoSlideIntervalMs]);

    return (
        <>
            <div
                className="SliderNav__item prev"
                onClick={onPrev}
                style={style}
            >
                <IoChevronBack/>
            </div>
            <div
                className="SliderNav__item next"
                onClick={onNext}
                style={style}
            >
                {autoSlideIntervalMs > 0 && (
                    <svg
                        width="40"
                        height="40"
                        viewBox="0 0 40 40"
                        className="SliderNav__item-progress"
                        style={{
                            animationDuration: `${autoSlideIntervalMs}ms`,
                        }}
                    >
                        <circle/>
                    </svg>
                )}
                <IoChevronForward/>
            </div>
        </>
    );
};

export default SliderNav;